import $ from 'jquery';

const ReadMore = (el) => {
    let $el = $(el);
    let lettersToShow = 250;
    let btnLessText = $('.js-read-more-btn').data('less-text');
    let btnMoreText = $('.js-read-more-btn').data('more-text');

    $el.each(function() {
        let content = $(this).html();

        if(content.length >= lettersToShow) {
            let showText = content.substr(0, lettersToShow);
            let showTextOnClick = content.substr(lettersToShow, content.length - lettersToShow);
            let html = showText + '<span class="question__dots">...</span>' + '<span class="question__moreText">' + showTextOnClick + '</span>';

            $(this).html(html);
        }
    });

    $('.question__moreBtn').unbind().click(function(){
        if($(this).parent().hasClass('question__less')) {
            $(this).parent().removeClass('question__less');
            $(this).removeClass('question__moreBtn--up');
            $(this).html(btnMoreText);
        } else {
            $(this).parent().addClass('question__less');
            $(this).addClass('question__moreBtn--up');
            $(this).html(btnLessText);
        }

        $(this).prev().toggle();
    });
};

export default ReadMore;
